module.exports = __webpack_public_path__ + "img/zyqsz.022ac8ad.jpg";